import { render } from "./NewsSlider.vue?vue&type=template&id=3523301a"
import script from "./NewsSlider.vue?vue&type=script&lang=js"
export * from "./NewsSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__